import { create } from 'zustand';
// utils
import { IAct } from '@newo/api/gateway';

type IActLogDrawerState = {
    act?: IAct;
    setAct: (act?: IAct) => void;
};

const initialState = {
    act: undefined
};

const useActLogDrawerStore = create<IActLogDrawerState>((set) => ({
    ...initialState,
    setAct: (act) => {
        set({ act });
    }
}));

export default useActLogDrawerStore;
